import { Routes } from '@angular/router';
import { APP_ROUTES } from '@core/constants/routes.constants';

export const authRoutes: Routes = [
  {
    title: 'pagesTitles.login',
    path: APP_ROUTES.LOGIN,
    loadComponent: () => import('./pages/login').then((m) => m.Login),
  },
  {
    title: 'pagesTitles.forgotPassword',
    path: APP_ROUTES.FORGOT_PASSWORD,
    loadComponent: () => import('./pages/forgot-password').then((m) => m.ForgotPassword),
  },
];
